import Button from 'components/shared/Button/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

const OrganizationConfirmationModal = ({
  isOpen,
  onClose,
  onMarkComplete,
  onSkip,
  onAddNewOrganization,
  isLoading
}) => {
  return (
    <Confirm
      isOpen={isOpen}
      handleClose={onClose}
      title="Continue without an organization?"
      message="You're not currently assigned to an organization. You can continue without one and come back later, or mark this step as complete if it doesn't apply to you."
      icon="info-filled"
      iconColor="primary"
      footer={
        <>
          <Button
            text="Mark complete"
            size="small"
            color="danger"
            variant="link"
            onClick={onMarkComplete}
            isDisabled={isLoading}
          />
          <Button
            text="Skip for now"
            size="small"
            style="outlined"
            color="neutral"
            onClick={onSkip}
            isDisabled={isLoading}
          />
          <Button
            text="Add new organization"
            size="small"
            variant="primary"
            onClick={onAddNewOrganization}
            isDisabled={isLoading}
          />
        </>
      }
    />
  );
};

export default OrganizationConfirmationModal;
